module.exports = require("@prisma/client/runtime/query_compiler_fast_bg.postgresql.mjs");